<template>
    <div class="pd video-tree">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <el-form-item class="form-title"  label="放映类型" >
                <el-radio class="mrl15 mrt5"  v-model="formData.radio" :label=2 @change="radiodata" :disabled="addedit">图片</el-radio>
                <el-radio class=" mrt5"  v-model="formData.radio" :label=1 @change="radiodata" :disabled="addedit">视频</el-radio>
<!--                <el-radio class="mrl15 mrt5"  v-model="radio" @change="radiodata" label="3" :disabled="addedit">链接</el-radio>-->
            </el-form-item>
            <el-form-item class="form-title"  label="是否循环" >
                <el-radio class="mrl15 mrt5"  v-model="formData.loop" :label=1 @change="loopdata" >是</el-radio>
                <el-radio class=" mrt5"  v-model="formData.loop" :label=0 @change="loopdata" >否</el-radio>
                <!--                <el-radio class="mrl15 mrt5"  v-model="radio" @change="radiodata" label="3" :disabled="addedit">链接</el-radio>-->
            </el-form-item>
            <el-form-item class="form-title"  label="是否拉伸" >
                <el-radio class="mrl15 mrt5"  v-model="formData.draw" :label=1 @change="drawdata" >是</el-radio>
                <el-radio class=" mrt5"  v-model="formData.draw" :label=0 @change="drawdata" >否</el-radio>
                <!--                <el-radio class="mrl15 mrt5"  v-model="radio" @change="radiodata" label="3" :disabled="addedit">链接</el-radio>-->
            </el-form-item>
            <el-form-item class="form-title" prop="vc_note" label="标题" >
                <el-input  v-model="formData.vc_note" placeholder="请输入">
                </el-input>
            </el-form-item>
            <el-form-item class="form-title proItem_info1" prop="imgList" label="放映内容">
                <span class="zs">多张图片轮播显示，每张图片大小不能超过1M</span>
                <div class="img-box">
                    <div class="uploadPhone flex fl-wr" id="uploadPhoto">
                        <ul v-if="imgList.length>0" class="flex">
                            <li v-for="(oneimg,index) in imgList" :key="index"
                                class="li-img mrr2" >
                                <img :src="oneimg.vc_path" v-if="formData.radio==2">
                                <video :src="oneimg.vc_path"  v-else controls="controls" ></video>
                                <i class="el-icon-delete" @click="removeli(oneimg,index)" ></i>
                            </li>
                        </ul>
                        <div class="upload-box flex1" v-model="formData.imgList">
                            <input type="file" name="files" value="" id="uploadfile1"
                                   class="upload-input uploadfile1" @change="upload" >
                            <img src="@/assets/custom_pic.png">
                        </div>
                        <el-button size="small" style="color:#c37f00;border: none; font-weight: bold;font-size: 14px"  @click="choosepic">[从素材库选择]</el-button>
                        <el-button size="small" style="color:#c37f00;border: none; font-weight: bold;font-size: 14px"  @click="inputsrc">[链接]</el-button>
                    </div>
                </div>
            </el-form-item>
            <!--<el-form-item class="form-title" prop="explain" label="链接"  :disabled="addedit">
                <el-table class="table"
                          border
                          ref="multipleTable"
                          :data="srcData"
                          size="mini"
                          tooltip-effect="dark">
                <el-table-column
                        align="left"
                        prop="vc_path"
                        label="链接"
                        width="800"
                        show-overflow-tooltip>
                    &lt;!&ndash;<template  slot-scope="scope" v-if="imputval==1">
                        <span>{{'http://192.168.8.5:8005'+scope.row.vc_path}}</span>
                    </template>&ndash;&gt;
                    <template  slot-scope="scope" v-if="imputval==2" >
                        <el-input  v-model="formData.explain" placeholder="请输入">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center"  width="50" >
                    <template slot="header" slot-scope="scope">
                            <el-button class="addbtn" @click="popShow(2)" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                    </template>
                    &lt;!&ndash;<template  slot-scope="scope">
                        <div class="iconminus">
                            <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                        </div>
                    </template>&ndash;&gt;
                </el-table-column>
                </el-table>
            </el-form-item>-->
            <el-form-item class="form-title" prop="vc_lruname" label="放映电视" >
                <div class="flex mrl20 mrb20 img-box">
                    <ul v-if="videoList.length>0" class="uploadPhon flex list" id="formul">
                        <li class="li-img item" v-for="(oneimg,index) in videoList" :key="index">
                            <span>{{oneimg.vc_name}}</span>
                            <!--<a
                                    :download="oneimg.vc_name"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+oneimg.filenewname+',deliver\'}','utf-8')">
                                &lt;!&ndash;:herf="file"&ndash;&gt;     {{oneimg.vc_name}}
                            </a>
                            <i class="el-icon-delete" @click="removeli(oneimg,index)" v-if="commit==false"></i>-->
                        </li>
                    </ul>
                    <!--<div class="upload-box" v-model="formData.videoList">
                        <input type="file" name="files" id="uploadfile1"
                               class="upload-input uploadfile1" @change="upload" style="margin-right: 10px">
                    </div>-->
                    <el-button size="small" style="color:#c37f00;border: none; font-weight: bold;font-size: 14px"  @click="videochange">[修改]</el-button>
                </div>
            </el-form-item>
            <el-form-item class="form-title" prop="begintime" label="开始时间" >
                <el-date-picker
                        class="input"
                        :disabled="addedit"
                        v-model="formData.begintime"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        type="datetime"
                        placeholder="选择开始日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="form-title" prop="endtime" label="放映时间" :rules="inputnum">
                <el-select v-model="value" placeholder="单位：分钟" :disabled="addedit" filterable  allow-create clearable size="mini" style="width: 22%" class="mrl20" @change="timesdata">
                    <el-option
                            v-for="item in times"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <!--<el-date-picker
                        class="input"
                        :disabled="addedit"
                        v-model="formData.endtime"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        type="datetime"
                        placeholder="选择结束日期时间">
                </el-date-picker>-->
            </el-form-item>
        </el-form>
        <div slot="footer"  class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" :disabled="disabled" size="mini">{{$t('button_save')}}</el-button>
            <el-button size="mini" @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>

        <!--dialog-->
        <div>
            <el-dialog
                    :class="baseerp+'div'"
                    width="400px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    :append-to-body="true"
                    @close="cancelDialog"
                    v-if="dialogVisible"
                    class="showAll_dialog">
                <choose-equipment :equipment="equipment" @close="cancelDialog" @getvalue="getvalue"></choose-equipment>
            </el-dialog>
        </div>
        <!--dialog-->
        <div>
            <el-dialog
                    :class="baseerp+'div'"
                    width="500px"
                    title="链接"
                    :visible.sync="inputdialogVisible"
                    :close-on-click-modal="false"
                    :append-to-body="true"
                    @close="quxiao"
                    v-if="inputdialogVisible">
                <el-input  v-model="srcsrc" placeholder="请输入"> </el-input>
                <div slot="footer"  class="dialog-footer" style="text-align: center">
                <el-button type="primary" @click="savesrc"  :class="baseerp+'btn'" :disabled="disabled" size="mini">{{$t('button_save')}}</el-button>
                <el-button size="mini" @click="quxiao">{{$t('button_cancel')}}</el-button>
                </div>
                <!--<el-table class="table"
                          border
                          ref="multipleTable"
                          :data="srcData"
                          size="mini"
                          tooltip-effect="dark">
                <el-table-column
                        align="left"
                        prop="vc_path"
                        label="链接"
                        width="600"
                        show-overflow-tooltip>
                    <template  slot-scope="scope">
                        <el-input  v-model="formData.explain" placeholder="请输入">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center"  width="50" >
                    <template slot="header" slot-scope="scope">
                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                    </template>
                    &lt;!&ndash;<template  slot-scope="scope">
                        <div class="iconminus">
                            <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                        </div>
                    </template>&ndash;&gt;
                </el-table-column>
                </el-table>
                <div slot="footer"  class="dialog-footer" style="text-align: center">
                    <el-button type="primary" @click="savesrc"  :class="baseerp+'btn'" :disabled="disabled" size="mini">保存</el-button>
                    <el-button size="mini" @click="quxiao">取 消</el-button>
                </div>-->
            </el-dialog>
        </div>
        <!--pic_dialog-->
        <div>
            <el-dialog
                    :class="baseerp+'div'"
                    width="550px"
                    :title="pic_title"
                    :visible.sync="pic_dialogVisible"
                    :close-on-click-modal="false"
                    :append-to-body="true"
                    @close="cancelDialog"
                    v-if="pic_dialogVisible"
                    class="showAll_dialog">
                    <choose-pic :pic="pic" @close="pic_cancelDialog" @getpicvalue="getpicvalue"></choose-pic>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import * as API from "../api"
    import chooseEquipment from "./chooseEquipment";
    import choosePic from "./choosePic";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    export default {
        name: "addSchedule",
        components:{chooseEquipment,choosePic},
        props:{
            application:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                inputnum:[
                    /*{ required: true, message: '输入不能为空'},
                    { type: 'number', message: '输入必须为数字值'}*/
                ],
                value:"",
                times: [{
                    value: 5,
                    label: '5分钟'
                }, {
                    value: 15,  // value: 60000 ,
                    label: '一刻钟'
                }, {
                    value: 30,
                    label: '半小时'
                }],
                pic_title:"选择素材",
                pic:{},
                pic_dialogVisible:false,
                scheduleId:"",
                showid:0,
                //isloop:"",
                srcsrc:"",
                inputdialogVisible:false,
                imputval:"",
                srcData:[],
                newarr:[],
                deleteLi: "",
                deleteLidex: "",
                imgList:[],
                videoList:[],
                equipment:{},
                dialogVisible:false,
                title:"",
                addedit:false,
                //shownum:'',
                radio:2,
                loop:1,
                draw:0,
                baseerp:"",
                /*********************************/
                edit:false,
                proname:"",
                formData:{
                    radio:2,
                    loop:1,
                    draw:0,
                    imgList:[],
                    videoList:[],
                    gsname:"",
                    cjname:"",
                    zdname:"",
                    proname:"",
                    ckname:"",
                    begintime:"",
                    endtime:"",
                    shul:0,
                    num:"000000",
                    vc_note:"",
                    vc_lruname: sessionStorage.getItem("lruname"),
                    date:"",
                    explain:"",
                },
                formRules:{
                    /*gsname:[{required:true,message:"请选择公司",trigger:"change"}],
                    cjname:[{required:true,message:"请选择车间",trigger:"change"}],
                    zdname:[{required:true,message:"请选择制定人",trigger:"change"}],
                    proname:[{required:true,message:"请选择产品",trigger:"change"}],
                    ckname:[{required:true,message:"请选择仓库",trigger:"change"}],
                    jgcost:[{required:true,message:"请输入加工费",trigger:"blur"}],
                    shul:[{required:true,message:"请输入数量",trigger:"blur"}],
                    endtime:[{required:true,message:"请选择结束日期",trigger:"change"}],
                    begintime:[{required:true,message:"请选择开始日期",trigger:"change"}],*/
                },
                companyName:[],
                groupName:[],
                personName:[],
                proList:[],
                warehouseName:[],
                gsid:0,
                ckid:0,
                pzid:0,
                cjid:0,
                i_id:0,
                i_type:9,
                wtgsid:0,
                zduid:0,
                zdname:"",
                pzname:"",
                wtname:"",
                gsname:"",
                cjname:"",
                lastTime:"",
                disabled:false,
                mid:0,
            }
        },
        watch:{

        },
        mounted() {
            this.baseerp=baseerp;
            //console.log("baseerp",this.baseerp);
            if (this.application){
                //console.log("从列表带到弹窗",this.application);
                this.scheduleId=this.application.schedule.i_id;
                let id = this.application.i_id;
                if (id==0){
                    this.addedit=false;
                    this.showid=0;
                }else{
                    //console.log(this.application,"this.application");
                    this.editData=this.application.value;
                    this.formData.begintime=this.editData.dt_startTime;
                    this.value=this.editData.dt_endTime;
                    this.formData.imgList=this.editData.contentList;
                    this.formData.loop=this.editData.i_isloop;
                    this.formData.radio=this.editData.i_type;
                    this.formData.draw=this.editData.i_isOverspread;
                    this.showid=this.editData.i_id;
                    //this.loop=this.editData.i_isloop;
                    //this.radio=this.editData.i_type;
                    this.imgList=this.editData.contentList;
                    this.videoList=this.editData.vcNameList;
                    this.formData.vc_note=this.editData.title;

                    this.equipment.select=this.editData.vcNameList;
                    this.pic.select=this.editData.contentList;
                    //console.log("this.equipment.select",this.equipment.select,"this.pic.select",this.pic.select);

                    this.addedit=true;
                    //console.log(this.formData.loop,"qweeeeeee", this.formData.radio);
                    //console.log(this.formData,"formdata");
                }
            };


        },
        computed:{
            //禁止跨月
            /*pickerOptions(){
                let _this = this
                return {
                    disabledDate(time) {
                        let start = new Date(_this.lastTime);
                        start.setDate(start.getDate());
                        return time.getTime() > start.getTime();
                    }
                }
            }*/
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),

            addZero (num) {
                if (parseInt(num) < 10) {
                    num = "0" + num
                }
                return num
            },

            timesdata(val){
                //console.log(val,"val");
                //this.value=val;
                //console.log(this.value,"value");
                //console.log("formData.begintime",this.formData.begintime);
                if(this.formData.begintime){
                    this.value=val;
                    let begintime= this.formData.begintime.replace(new RegExp("-","gm"),"/");
                    var changetime = (new Date(begintime)).getTime(); //得到毫秒数
                    //console.log("changetime",changetime);
                    let end=changetime+(val*60000);
                    //console.log("end",end);
                    let oDate = new Date(end),
                        oYear = oDate.getFullYear(),
                        oMonth = oDate.getMonth() + 1,
                        oDay = oDate.getDate(),
                        oHour = oDate.getHours(),
                        oMin = oDate.getMinutes(),
                        //oSen = oDate.getSeconds(),
                        oTime = oYear + '-' + this.addZero(oMonth) + '-' + this.addZero(oDay) + ' ' + this.addZero(oHour) + ':' +
                                this.addZero(oMin) ;// + ':' + this.addZero(oSen);
                        //console.log("oTime",oTime);
                        this.formData.endtime= oTime;
                }else{
                    this.value="";
                    this.$message.error("请先选择开始时间");

                }
                //console.log("this.formData.endtime",this.formData.endtime);
            },

            savesrc(){
                //console.log(this.srcsrc,"this.srcsrc");
                let obj={};
                obj.vc_path=this.srcsrc;
                this.imgList.push(obj);
                this.formData.imgList=this.imgList;
                //console.log(this.formData,"this.formData");
                this.inputdialogVisible=false;

            },

            quxiao(){
                //console.log(this.srcsrc,"this.srcsrc");
                this.inputdialogVisible=false;
            },

            choosepic(){
                this.pic.i_type=this.formData.radio;
                this.pic_dialogVisible=true;
            },

            inputsrc(){
                this.srcsrc="";
                this.inputdialogVisible=true;
            },

            popShow(val){
              this.imputval=val;
              this.srcData.push('');
            },


            getvalue(val){
                //console.log(val,"val");
                this.videoList=val;
                this.equipment.select=this.videoList;
                //console.log(this.equipment,"this.equipment");
            },

            getpicvalue(val){
                //console.log(val,"val");
                this.pic.select=val;
                this.imgList=val;
                this.formData.imgList=this.imgList;
                //console.log(this.imgList,"imglist");
                //console.log(this.formData,"this.formData");

            },

            //删除li
            removeli(oneimg, index) {
                //console.log(oneimg, index, "oneimg")
                this.deleteLi = oneimg.i_fileid;
                this.deleteLidex = index;
                this.deletefile();
            },
            //li删除接口
            async deletefile() {
                this.imgList.splice(this.deleteLidex, 1);
                /*let param = {
                    i_id: this.deleteLi,
                };
                let res = await API.deleteFileInfo(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.imgList.splice(this.deleteLidex, 1);
                    //console.log(this.imgList, "newlist");
                    this.newarr = this.imgList;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }*/
            },

            pic_cancelDialog(){
                this.pic_dialogVisible=false;
            },

            cancelDialog(){
                this.dialogVisible=false;
            },

            videochange(){
                this.title="选择放映电视";
                this.dialogVisible=true;

            },

            radiodata(val){
                //console.log(val,"val");
                this.formData.radio=val;
                this.imgList=[];
            },

            loopdata(val){
                this.formData.loop=val;
            },

            drawdata(val){
                this.formData.draw=val;
            },



            async saveForm(){
                if (this.radio!=3){
                    this.newarr = this.imgList.map((item, index, arr) => {
                        //return item.fileid;
                        return item.vc_path;
                    });
                    //console.log(this.newarr, "newarrr");
                }else{
                    this.newarr.push(this.formData.explain);
                }
                let param={
                    //i_state:1,
                    i_pid:this.scheduleId,
                    i_id:this.showid,
                    dt_startTime: this.formData.begintime,
                    dt_endTime: this.formData.endtime,
                    i_isLoop:this.formData.loop,
                    i_type:this.formData.radio,
                    i_isOverspread:this.formData.draw,
                    title:this.formData.vc_note,
                    deviceList:this.videoList,
                    contentList:this.imgList,
                };
                //console.log("param",param);
                let res=await API.arrangeProgram(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.$emit("close");
                    this.$emit("getArrangementList");
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            taskList(data){
                // console.log("data",data);
                let val={
                    i_itype:this.i_type,
                    expanded: true,
                    data:data,
                }
                this.$emit('proDetails',val);
            },


            cancel(){
                 this.$emit('close');
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            //得到最后一天
            getLastDay(val){
                let date=new Date(this.formData.begintime);
                date.setDate(28);
                date.setMonth(date.getMonth()+1);
                let lastDay=date.setDate(0);
                let allDay= new Date(lastDay).toString();
                const lastdate = new Date(allDay);
                const month = (lastdate.getMonth() + 1).toString().padStart(2, '0');
                const strDate = lastdate.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.lastTime=`${lastdate.getFullYear()}-${month}-${strDate}`;
                this.$set(this.formData, "endtime",this.lastTime)
                // console.log( value)
            },

            //上传附件
            async upload(value) {
                    this.imputval=1;
                //console.log(this.commitId, "thie.commitId")
                    //console.log(value, "vaaaaaaaaaaaaaaa")
                    let that = this;
                    let i = 0;
                    let $files = value.target.files[0];
                    let fileName = $files.name;
                    let type = $files.type;
                    var list = {
                        "image/jpeg": true,
                        "image/png": true,
                        "image/jpg": true,
                        "image/bmp": true,
                        "application/pdf": true
                    };
                    let result = list[type];
                    // if(($files && result==false) || ($files &&result==undefined)){
                    //     that.$message.error('请上传格式正确的文件');
                    //     return;
                    // };
                    if ($files) {
                        that.fileName = $files.name;
                        that.fileType = $files.type;
                        that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                    } else {
                        that.fileName = "";
                        that.fileType = "";
                        that.fileUrl = "";
                    }
                    if (that.fileName) {
                        var fileId = 'uploadfile' + that.idNum;
                        var param = {
                            "file": fileId,
                            "fileName": that.fileName,
                            "IDtype": "",
                            "type": 1,
                            "style": "video",
                            "files": $files,
                            //"token":sessionStorage.getItem("token"),
                            //"app": "dsmanage",
                            "vc_app": "video",
                            "i_appid":0,
                            "version": "1.0",
                            "i_uid": sessionStorage.getItem("userid"),
                            //"vc_lruname": this.form.vc_lruname,
                            //"i_lruid": this.form.i_lruid,
                            "i_mid": this.mid
                        };
                        /*let abc = {
                            i_mid: this.mid,
                            style:"deliver",
                            vc_app:"deliver",
                            i_appid:this.commitId,
                            vc_lruname:this.form.vc_lruname,
                            i_lruid:this.form.i_lruid,
                        };*/
                        let FD = new FormData();
                        for (let key in param) {
                            FD.append(key, param[key])
                        }
                        // let res = await  fetch(upload,{
                        //     method:"post",
                        //     body:FD
                        // }).then(res=>res.text());
                        let res = await API.upload(param);
                        if (res.code == 1) {
                            //res =JSON.parse(res);
                            let data = res.data[0];
                            var imgPath = {};
                            imgPath.i_fileid = data.i_id;
                            //imgPath.vc_name = data.filename;
                            imgPath.vc_path = file_root+data.vc_path;
                            //imgPath.base64 = data.base64String;
                            //imgPath.filePath = data.i_id;
                            //imgPath.fileSort = that.didNum;
                            //imgPath.fileType = 1;
                            //imgPath.filenewname = data.filenewname;
                            that.imgList.push(imgPath);
                            that.didNum++;
                            that.idNum = that.didNum;
                            that.imgLength = that.imgList.length - 1;
                            that.formData.imgList = that.imgList;
                            //console.log(that.imgList,"that.imgList11111111111");

                            //that.srcData=that.imgList;
                            //that.Data=[...that.srcData];
                            //console.log(data, that.imgList, that.formData.imgList, "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
                            //this.removeli();
                            //console.log(that.imgList, "newlist")
                        } else if (res.code == -2) {
                            this.$router.push('/login');
                            this.$message.error(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    }
            },
        },
    }
</script>

<style lang="scss" scoped>

    .mrb10{
        margin-bottom: 10px;
    }

    .showAll_dialog {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        ::v-deep .el-dialog {
            margin: 0 auto !important;
            height: 60%;
            overflow: hidden;
            //background-color: black;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }


    .mrr2{
        margin-right: 2px;
    }

    .flex- {
        display: flex;
        flex-flow: wrap;
        justify-content: flex-start;
        align-items: center;
    }



    .mrr15{
        margin-right: 15px;
    }

    /***********************************/
    .pd{
        min-width: 500px;
    }
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }





    /deep/{
        .ghwdiv .el-dialog__header{
            background-color: #3e82e8;
        }


        .havaydiv .el-dialog__header{
            background-color: #e8c984;
        }

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }
        .el-tabs--border-card > .el-tabs__content{
            height: calc(100% - 60px);
            overflow-y: auto;

        }
    }

    /deep/{

        .input .el-input__inner{
            width: 200px;
        }

        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        /* .el-table td,.el-table td, .el-table th {
             padding: 8px 0;
         }*/
        .danger-row{
            color: #999;
        }

    }

    /*@media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 600px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 600px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 600px;
        }
    }

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
    }*/
    .proItem_info1{
        text-align: left;
        .one-title{
            width: 100px;
            display: inline-block;
            text-align: center;
        }
        /deep/{
            .el-icon-star-on{
                display: inline-block;
                vertical-align:super;
            }

        }
        .zs{
            padding-left: 16px;
            color: #a0a0a0;
        }
        .img-box{
            /*border: 1px solid red;*/
            margin: 10px;
            .uploadPhone{
                width: 70px;
                height: 80px;
                position: relative;
                width: 100%;
                /*border: 1px solid cornflowerblue;*/
            }
            .uploadPhone img{
                width: 70px;
                height: 80px;
            }

            .uploadPhone video{
                width: 70px;
                height: 80px;
            }

            .upload-box{
                /*background: red;*/
                width: 10%;
                height: 100%;
            }
            .upload-input{
                position: absolute;
                opacity: 0;
                width: 70px;
                height: 80px;
            }
        }
        .flex1{
            display: flex;
        }
    }
</style>